import http from "../../utils/http";

// 세금계산서 통계
export const getStatisticsTaxInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/tax-invoices", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드 통계 매입
export const getStatisticsCardPurchases = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/infotech-card-purchases", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 카드 통계 매출
export const getStatisticsCardSales = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/card-sales-summaries", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 통계
export const getStatisticsCashReceipts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/cash-receipts", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 현금영수증 통계
export const getStatisticsBank = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/bank-trans", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 통계
export const getStatisticsInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/invoices", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여내역 통계
export const getStatisticsSalaryHistory = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/salary-histories", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입 매출 현황 조회
export const getStatisticsTradeSummaries = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/trade/summaries", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카테고리별 신용카드 구입 통계
export const getStatisticsCategoriesCardPurchases = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/categories/infotech-card-purchases", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카테고리별 은행매입출 통계
export const getStatisticsCategoriesBankTrans = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/categories/bank-trans", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카테고리별 카드 매출건 통계
export const getStatisticsCategoriesCardSales = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/statistics/categories/card-sales", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};